// parameter 타입(년, 월, 일), 숫자

import { checkNum10 } from "../../../modules/utils/CheckLogic";

// return -> { startDate:'20230119', endDate: '20230119' }
export const PeriodEvent = (period) => {
  const date = new Date();
  const toYear = date.getFullYear();
  const toMonth = date.getMonth() + 1;
  const toDate = date.getDate();

  let returnDate;

  if (period === 1) {
    returnDate = new Date(date.setMonth(toMonth - 3));
  }

  if (period === 2) {
    returnDate = new Date(date.setMonth(parseInt(toMonth) - 6));
  }

  if (period === 3) {
    returnDate = new Date(date.setFullYear(toYear - 1));
  }

  return {
    startDate:
      returnDate.getFullYear() +
      "" +
      checkNum10(returnDate.getMonth() + 1) +
      "" +
      checkNum10(returnDate.getDate()),
    endDate: toYear + "" + checkNum10(toMonth) + "" + checkNum10(toDate),
  };
};
